import type { Tokens } from '@zeus/themes';

import { type CSSObject, type ThemeOptions } from '@mui/material';

const typographyVariants = [
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'subtitle1',
  'subtitle2',
  'body1',
  'body2',
  'caption',
  'button',
  'overline',
] as const;

export function createTypographyStyles(tokens: Tokens) {
  return {
    MuiTypography: {
      styleOverrides: {
        root: ({ theme }) => ({
          '&.Mui-focusVisible': {
            borderRadius: `${theme.ui.focus.borderRadius}`,
            outline: `${theme.ui.focus.outlineWidth} solid ${theme.palette.action.focusOutline}`,
            outlineOffset: `${theme.ui.focus.outlineOffset}`,
          },
          '&.MuiTypography-gutterBottom, &.MuiTypography-paragraph': {
            ...typographyVariants.reduce(function mapVariantMarginBottom(
              styles,
              variant
            ) {
              const paragraphSpacing =
                tokens.typography[variant]?.paragraphSpacing;

              return {
                ...styles,
                ...(paragraphSpacing && {
                  [`&.MuiTypography-${variant}`]: {
                    marginBottom: paragraphSpacing,
                  },
                }),
              };
            }, {} as CSSObject),
          },
        }),
      },
    },
  } as ThemeOptions['components'];
}
